"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserIcon = UserIcon;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function UserIcon() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none"
    }, /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0_7168_65343)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M20 20C22.4862 20 24.5 17.9862 24.5 15.5C24.5 13.0138 22.4862 11 20 11C17.5138 11 15.5 13.0138 15.5 15.5C15.5 17.9862 17.5138 20 20 20ZM20 22.25C16.9963 22.25 11 23.7575 11 26.75V29H29V26.75C29 23.7575 23.0037 22.25 20 22.25Z",
      fill: "#707A95"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0_7168_65343"
    }, /*#__PURE__*/React.createElement("rect", {
      width: "40",
      height: "40",
      rx: "20",
      fill: "white"
    }))))
  );
}